/**
 * @generated SignedSource<<f7df15b04653e82013f84181fd278b63>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespUnavailableContainer_viewer$data = {
  readonly isWordpressArticlesEnabled: boolean | null;
  readonly pdpOptinPromptFF: boolean | null;
  readonly similarLandingItems?: {
    readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarItemsLanding_similarItems">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedHeroCarousel_viewer" | "PdpRespSharedItemsRefetchCarouselConfig_YMAL_viewer" | "PdpRespSharedItemsRefetchCarouselConfig_sellerYMAL_viewer" | "PdpRespSharedSellerChatLoader_viewer" | "PdpRespSimilarAuctionItemsLazy_viewer" | "PdpRespUnavailableDetailsTabs_viewer" | "PdpRespUnavailableHeaderYMAL_viewer" | "SharedRespLinksBlock_viewer" | "usePdpSharedTracking_viewer">;
  readonly " $fragmentType": "PdpRespUnavailableContainer_viewer";
};
export type PdpRespUnavailableContainer_viewer$key = {
  readonly " $data"?: PdpRespUnavailableContainer_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespUnavailableContainer_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchChat"
    },
    {
      "kind": "RootArgument",
      "name": "isSoldPDPV1Variant"
    },
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "itemId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespUnavailableContainer_viewer",
  "selections": [
    {
      "alias": "pdpOptinPromptFF",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "pdpOptinPrompt"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"pdpOptinPrompt\")"
    },
    {
      "alias": "isWordpressArticlesEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "WP_EDITORIAL"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale(featureName:\"WP_EDITORIAL\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "usePdpSharedTracking_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRespLinksBlock_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespUnavailableHeaderYMAL_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespUnavailableDetailsTabs_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedHeroCarousel_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedItemsRefetchCarouselConfig_YMAL_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedItemsRefetchCarouselConfig_sellerYMAL_viewer"
    },
    {
      "condition": "fetchChat",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSharedSellerChatLoader_viewer"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarAuctionItemsLazy_viewer"
    },
    {
      "condition": "isSoldPDPV1Variant",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "similarLandingItems",
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 6
            },
            {
              "kind": "Variable",
              "name": "isTrade",
              "variableName": "isTrade"
            },
            {
              "kind": "Variable",
              "name": "itemId",
              "variableName": "itemId"
            },
            {
              "kind": "Literal",
              "name": "seller",
              "value": "EXCLUDE"
            }
          ],
          "concreteType": "moreLikeThisItemConnection",
          "kind": "LinkedField",
          "name": "moreLikeThisItem",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespSimilarItemsLanding_similarItems"
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "84098ed7615e741f433d98629ce082fa";

export default node;
